import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

/** `{{vittoria}}/v1/notifications` */
const notificationsApiUrl: string = environment.VITTORIA_BACKEND_URL + environment.NOTIFICATIONS_BACKEND_URL;

@Injectable({
  providedIn: 'root'
})
export class NotificationApiService {

  constructor(public _http: HttpClient) { }

    public deleteNotification(notificationId: any): Observable<any> {
      let params = new HttpParams();
      params = params.append('eventId', notificationId);
      return this._http.delete(notificationsApiUrl, {
        params
      });
    }

    public deleteMultipleNotifications(notificationIds: any[]): Observable<any> {
      return this._http.request<any>('delete', notificationsApiUrl, {
        body: notificationIds
      });
    }
}
